<template>
    <contacts-store
        v-slot="{
            sid,
            data: contact,
            error,
            is_loading,
            has_loaded,
            store,
            forget
        }"
        @success="onContactsStoreSuccess"
    >
        <contacts-edit-or-create-form
            :sid="sid"
            :is-loading="is_loading"
            :has-loaded="has_loaded"
            @submit="store"
        >
            <template v-slot:modals="{ reset }">
                <pre>{{ $route.query.with }}</pre>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [422] })"
                    :error="error"
                />

                <template v-if="contact">
                    <template v-if="$route.query.then === 'create-job-sheet'">
                        <modal-success
                            :is-open="show_created_modal"
                        >
                            <template slot="heading">Contact created!</template>

                            <p>
                                You can now create a job sheet for this contact.
                            </p>

                            <div
                                slot="footer"
                                class="flex flex-col md:flex-row-reverse"
                            >
                                <router-link
                                    :to="{
                                        name: $router.fix('dashboard.*.job-sheets.create'),
                                        query: {
                                            maintenance: $route.query.maintenance,
                                            contact: contact.uuid
                                        }
                                    }"
                                    class="text-center btn btn-green"
                                >
                                    Create a Job Sheet
                                </router-link>

                                <router-link
                                    :to="{
                                        name: $router.fix('dashboard.*.contacts.show'),
                                        params: {
                                            contact: contact.uuid
                                        }
                                    }"
                                    class="mt-3 text-center btn md:mt-0 md:mr-3"
                                >
                                    Go to Contact
                                </router-link>
                            </div>
                        </modal-success>
                    </template>

                    <template v-else>
                        <modal-success
                            :is-open="show_created_modal"
                            @close="(function () {
                                show_created_modal = false;
                                forget();
                                reset(sid);
                            })()"
                        >
                            <template slot="heading">Contact created!</template>

                            <p>
                                Your contact has been created.
                            </p>

                            <div
                                slot="footer"
                                slot-scope="{ close }"
                                class="flex flex-col md:flex-row-reverse"
                            >
                                <router-link
                                    :to="{
                                        name: $router.fix('dashboard.*.contacts.show'),
                                        params: {
                                            contact: contact.uuid
                                        }
                                    }"
                                    class="text-center btn btn-green"
                                >
                                    Go to Contact
                                </router-link>

                                <button
                                    type="button"
                                    @click.prevent="close"
                                    class="mt-3 text-center btn md:mt-0 md:mr-3"
                                >
                                    Add another
                                </button>
                            </div>
                        </modal-success>
                    </template>
                </template>
            </template>
        </contacts-edit-or-create-form>
    </contacts-store>
</template>

<script>
    import ContactsEditOrCreateForm from '../../../../components/contacts-edit-or-create-form'
    import ContactsStore from '../../../../components/contacts-store'

    export default {
        components: {
            ContactsEditOrCreateForm,
            ContactsStore
        },
        data () {
            return {
                show_created_modal: false
            }
        },
        methods: {
            onContactsStoreSuccess () {
                this.$track(
                    'dashboard.landlords.contacts.create',
                    'form-submission',
                    'A landlord has created a contact'
                )

                setTimeout(() => {
                    this.show_created_modal = true
                }, 0)
            }
        }
    }
</script>
